export default function postGrid(postTypes, taxonomies, perPageOptions: number[], blockId, preFilter) {
    return {
        blockId,
        posts: [],
        filteredPosts: [],
        filters: {
            post_type: [],
            ...taxonomies.reduce((acc, taxonomy) => {
                acc[taxonomy.name] = [];
                return acc;
            }, {}),
        },
        searchQuery: '',
        postType: [postTypes],
        currentPage: 1,
        perPage: perPageOptions[1],
        totalPages: 1,
        isLoading: false,
        preFilter: preFilter,
        checkboxStates: {},

        init() {
            this.fetchPosts();
            this.initializeCheckboxStates();
            this.$nextTick(() => {
                this.checkPreFilter();
            });
            this.$watch('filters', () => {
                this.currentPage = 1;
                this.fetchPosts();
            });
            this.$watch('searchQuery', () => {
                this.currentPage = 1;
                this.fetchPosts();
            });
        },

        async fetchPosts() {
            this.isLoading = true;
            const params = new URLSearchParams();
        
            if (this.searchQuery) {
                params.append('search', this.searchQuery);
            }
        
            Object.keys(this.filters).forEach(taxonomy => {
                if (this.filters[taxonomy].length) {
                    params.append(taxonomy, this.filters[taxonomy].join(','));
                }
            });
        

            if (this.preFilter && this.filters.post_type.length === 0) {
                params.append('post_type', this.preFilter);
            } else if (this.filters.post_type.length > 0) {
                params.append('post_type', this.filters.post_type.join(','));
            } else {
                params.append('post_type', this.postType.join(','));
            }
        
            params.append('page', this.currentPage.toString());
            params.append('perPage', this.perPage.toString());
                
            try {
                const response = await fetch(`/api/takt/v1/resources?${params.toString()}`);
                const data = await response.json();
        
                this.posts = data.resources || [];
                this.filteredPosts = this.posts;
                this.totalPages = data.total_pages || 1;
        
            } catch (error) {
                console.error('Error fetching posts:', error);
            } finally {
                this.isLoading = false;
            }
        },

        toggleFilter(taxonomy, termId) {        
            if (this.filters[taxonomy].includes(termId)) {
                this.filters[taxonomy] = this.filters[taxonomy].filter(slug => slug !== termId);
            } else {
                this.filters[taxonomy].push(termId);
            }

            this.preFilter = null;
            this.currentPage = 1;
            this.fetchPosts();
        },

        updatePostType(postType) {
            const checkbox = this.$refs[`checkbox-${postType}`] as HTMLInputElement;
        
            if (this.filters.post_type.includes(postType)) {
                this.filters.post_type = this.filters.post_type.filter(type => type !== postType);
                this.checkboxStates[postType] = false;
                if (checkbox) checkbox.checked = false;
            } else {
                this.filters.post_type.push(postType);
                this.checkboxStates[postType] = true;
                if (checkbox) checkbox.checked = true;
            }
        
            this.preFilter = null;
            this.currentPage = 1;
            this.fetchPosts();
        },

        clearFilters() {
            Object.keys(this.filters).forEach(taxonomy => {
                this.filters[taxonomy] = [];
            });
            this.searchQuery = '';
            this.currentPage = 1;
            this.fetchPosts();
            this.uncheckAll();
            this.clearSearchInput();
        },

        clearSearchInput() {
            const searchInput = this.$refs.searchInput as HTMLInputElement;

            if (searchInput) {
                (searchInput as HTMLInputElement).value = '';
            }
        },

        uncheckAll() {
            document.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
                (checkbox as HTMLInputElement).checked = false;
            });
        },

        updateSearch(query) { 
            this.searchQuery = query.toLowerCase();
        },

        checkPreFilter() {
            if (this.preFilter) {
                this.$nextTick(() => {
                    const checkbox = document.querySelector(`input[type="checkbox"][value="${this.preFilter}"]`) as HTMLInputElement || null;
                    if (checkbox && this.preFilter) {
                        checkbox.checked = true; 
                        this.checkboxStates[this.preFilter] = true; 
                        if (!this.filters.post_type.includes(this.preFilter)) {
                            this.filters.post_type.push(this.preFilter);
                        }
                    } else {
                        console.warn(`Checkbox for preFilter "${this.preFilter}" not found.`);
                    }
                });
            }
        },

        initializeCheckboxStates() {
            document.querySelectorAll('input[type="checkbox"][data-x-ref]').forEach((checkbox: HTMLInputElement) => {
            const value = checkbox.value;
            this.checkboxStates[value] = checkbox.checked;
            });
        },

        updatePerPage(perPage: number) {
            this.perPage = parseInt(perPage.toString(), 10);
            this.currentPage = 1;
            this.fetchPosts();
            this.scrollToTop();
        },

        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
                this.fetchPosts();
                this.scrollToTop();
            }
        },

        nextPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage++;
                this.fetchPosts();
                this.scrollToTop();
            }
        },

        scrollToTop() {
            const gridElement = this.$el.closest('.post-grid');
            if (gridElement) {
                gridElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        },

        goToPage(page) {
            this.currentPage = page;
            this.fetchPosts();
            this.scrollToTop();
        },

        get paginatedPosts() {
            if (!this.filteredPosts || this.filteredPosts.length === 0) {
                return [];
            }
            const start = (this.currentPage - 1) * this.perPage;
            const end = start + this.perPage;
            const paginated = this.posts.slice(start, end);

            return paginated;
        },

        get pagesToShow() {
            const pages = [];
            const totalPages = this.totalPages;
            const currentPage = this.currentPage;
            const maxPagesToShow = 5;

            if (totalPages <= maxPagesToShow) {
                for (let i = 1; i <= totalPages; i++) {
                    pages.push(i);
                }
            } else {
                const startPage = Math.max(1, currentPage - 2);
                const endPage = Math.min(totalPages, currentPage + 2);

                if (startPage > 1) {
                    pages.push(1);
                    if (startPage > 2) {
                        pages.push('...');
                    }
                }

                for (let i = startPage; i <= endPage; i++) {
                    pages.push(i);
                }

                if (endPage < totalPages) {
                    if (endPage < totalPages - 1) {
                        pages.push('...');
                    }
                    pages.push(totalPages);
                }
            }

            return pages;
        },
    };
}